import type React from "react";
import { UI_ICONS } from "../../../icons";

interface PreferenceApiKeysTabProps {
	geminiKey: string;
	showGeminiKey: boolean;
	onToggleGeminiKey: () => void;
	onChangeGeminiKey: (value: string) => void;
}

export const PreferenceApiKeysTab: React.FC<PreferenceApiKeysTabProps> = ({
	geminiKey,
	showGeminiKey,
	onToggleGeminiKey,
	onChangeGeminiKey,
}) => {
	return (
		<div className="flex flex-col gap-8">
			<div className="flex flex-col gap-4">
				<h3 className="m-0 mb-4 text-[1.1rem] text-primary border-b border-border-main pb-2">
					APIキー設定
				</h3>
				<div className="bg-primary/10 border border-primary/20 rounded-lg p-4 mb-4">
					<p className="text-sm m-0 flex items-center gap-2">
						{UI_ICONS.INFO}
						<span>
							APIキーは{" "}
							<a
								href="https://aistudio.google.com/api-keys"
								target="_blank"
								rel="noopener noreferrer"
								className="text-primary hover:underline font-semibold"
							>
								Google AI Studio
							</a>{" "}
							から無料で取得できます。
						</span>
					</p>
				</div>
				<div className="flex flex-col gap-2 bg-bg-main p-3 rounded-lg border border-border-main mb-3">
					<label
						className="text-xs font-semibold text-text-dim"
						htmlFor="gemini-api-key"
					>
						Gemini APIキー <span className="text-red-500">*</span>
					</label>
					<div className="flex gap-2 relative">
						<input
							id="gemini-api-key"
							className="flex-1 p-2.5 bg-card-bg border border-border-main rounded-md text-text-main text-sm focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
							type={showGeminiKey ? "text" : "password"}
							value={geminiKey}
							onChange={(e) => onChangeGeminiKey(e.target.value)}
						/>
						<button
							type="button"
							className="toggle-password bg-transparent border border-border-main rounded-md text-text-dim cursor-pointer px-2.5 flex items-center justify-center min-w-[40px] focus-visible:ring-2 focus-visible:ring-primary focus-visible:outline-none active:scale-95"
							onClick={onToggleGeminiKey}
							title={showGeminiKey ? "APIキーを隠す" : "APIキーを表示する"}
							aria-label={showGeminiKey ? "APIキーを隠す" : "APIキーを表示する"}
						>
							{showGeminiKey
								? UI_ICONS.PASSWORD_HIDDEN
								: UI_ICONS.PASSWORD_VISIBLE}
						</button>
					</div>
				</div>
			</div>
		</div>
	);
};
